import { Modal } from "@gravity-ui/uikit";

import { ChangeUserDataContent } from "../ChangeUserDataContent";

interface ChangeUserDataModalProps {
  open: boolean;
  isLoading: boolean;
  hasPhone?: boolean;
  onClose: () => void;
}

export const ChangeUserDataModal = ({
  open,
  isLoading,
  onClose,
  hasPhone,
}: ChangeUserDataModalProps) => {
  return (
    <Modal open={open} onClose={onClose}>
      <ChangeUserDataContent
        isLoading={isLoading}
        isModal={true}
        onClose={onClose}
        hasPhone={hasPhone}
      />
    </Modal>
  );
};
